import { dataImage } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImage = /*#__PURE__*/createIcon(dataImage)
export default IconImage
